export const API_ERRORS = {
    invalidRefreshToken: 'invalid_refresh_token',
    refreshTokenExpired: 'refresh_token_expired',
    noToken: 'no_jwt',
    tokenExpired: 'token_expired',
    gameSessionEnded: 'game_session_ended',
    noInternet: 'no_internet',
    invalidGameSession: 'invalid_game_session',
};
